import React from 'react';
import memoize from 'memoize-one';
import VerticalCellRenderer from '../../components/LegalReport/VerticalCellRenderer';

const baseColumns = [
  {
    name: 'Razón Social',
    selector: 'company_name',
    sortable: false,
    grow: '2'
  },
  {
    name: 'Rut del Empleador',
    selector: 'company_national_id',
    sortable: false,
    grow: '2'
  },
  {
    name: 'Nombre',
    selector: 'full_name',
    sortable: false,
    grow: '2'
  },
  {
    name: 'Rut Colaborador',
    selector: 'national_identification',
    sortable: false,
    grow: '2'
  },
  {
    name: 'Lugar de Prestación de Servicio',
    selector: 'branch_offices_name',
    sortable: false,
    grow: '2'
  },
  {
    name: 'Cargo',
    selector: 'job_title',
    sortable: false,
    grow: '2',
    center: true
  },
  {
    name: 'Banda Horaria',
    selector: 'is_article_27',
    sortable: false,
    grow: '2',
    center: true
  }
];

const LegalReportsColumns = memoize((isDtUser = false, columnsConfig = baseColumns) => {
  if (!isDtUser) {
    return columnsConfig;
  }

  // Para usuarios DT: solo 1 columna con toda la información en formato vertical
  return [
    {
      name: '', // Sin título de columna
      selector: 'full_name', // Selector dummy, no se usa
      sortable: false,
      grow: '1',
      cell: row => <VerticalCellRenderer row={row} columns={columnsConfig} />
    }
  ];
});

export default LegalReportsColumns;
